/*
 * @Author: shuchang
 * @Date: 2021-06-03 17:12:21
 * @LastEditors: shuchang
 * @LastEditTime: 2021-06-17 10:42:56
 * @Description: 
 */
module.exports = {
    API_URL: "https://apiobs.guojutech.net/",
    FILE_URL: "",
    SSO_URL:"https://ssoobs.guojutech.net/"
}